/* eslint-disable no-case-declarations */
/* eslint-disable prefer-destructuring */
import parse, { Element as ParseElement, DOMNode } from 'html-react-parser';
import React, { useMemo } from 'react';
import extractImageFromTable from '../../../utils/extract-Image-Table';
import getObjectByKey from '../../../utils/get-Image-By-Key';
import Image from '../../image';
import Attachment from '../../attachment';
import Highlight from '../../box-highlight';
import GamesAndPlay from '../../games-and-play';
import MediaPlayer from '../../media-player';
import NextClass from '../../next-class';
import ProjectBox from '../../projects-components';
import Quotations from '../../quotation-component';
import ReminderBox from '../../reminder-box';
import WrapContent from '../../wrap-content';
import { NotesContextProvider } from '../../../contexts/NotesContext';
import Glossary from '../../glossary';
import Accordion from '../../accordion';
import TabContent from '../../tab';
import extractTabsFromTable from '../../../utils/extract-tabs-from-table';
import extractAccordionTable from '../../../utils/extract-accordion-table';

export default function LessonStructure({ doc }: { doc: Document }) {
  const h3Title = doc.querySelector<HTMLParagraphElement>('h3');
  const title = h3Title?.textContent || '';
  const lesson = doc.querySelector('.page');
  let childrenArray: any[] = [];

  if (lesson) {
    const childrenCollection = lesson.children;
    childrenArray = Array.from(childrenCollection);
    childrenArray = childrenArray.filter(
      (child) => !child.classList.contains('tituloArtigo')
    );
  }

  const notes = useMemo(() => {
    const notesTable = childrenArray[childrenArray.length - 1];
    const notes: string[] = [];

    if (lesson && childrenArray.length > 0 && notesTable.classList.contains('notas')) {
      notesTable.querySelectorAll('td').forEach((description: { innerHTML: any; }, index: number) => {
        if (index > 0 && index % 2 === 0) notes.push(description.innerHTML);
      });
    }

    return notes;
  }, [lesson]);

  const replace = (domNode: DOMNode) => {
    if (
      domNode instanceof ParseElement &&
      domNode.attribs &&
      ['numeroRodape', 'termoGlossario'].includes(domNode.attribs.class)
    ) {
      return <Glossary domNode={domNode} />;
    }

    return domNode;
  };

  const renderContent = (child: Element) => {
    const content = child.querySelectorAll('p, ol, ul');
    const tablecontent = child.querySelectorAll('table');
    const isObject = !['p', 'ol', 'ul', 'h4', 'h5', 'h6'].includes(child.tagName.toLowerCase());
    const stringContent = isObject
      ? Array.from(content)
          .map((element) => element.outerHTML)
          .join('')
      : child.outerHTML;

    const tableContentIsObject = !['table'].includes(
      child.tagName.toLowerCase()
    );
    const stringTableContent = tableContentIsObject
      ? Array.from(tablecontent)
          .map((element) => element.outerHTML)
          .join('')
      : child.outerHTML;

    const attachmentPath = stringContent.replaceAll(/<p>|<\/p>|Anexo/g, '');

    const formattedString = stringContent.replaceAll(/-/g, '‑');

    switch (child.classList[0]) {
      case 'notas':
        return;
      case 'accordion':
        return <Accordion data={extractAccordionTable(child)} />;
      case 'boxLembrete':
        return <ReminderBox subject="portuguese" content={formattedString} />;
      case 'midiaImagem':
        const image = extractImageFromTable(child);
        return (
          <Image
            src={getObjectByKey(image.retranca)}
            texto_alternativo={image?.texto_alternativo}
            legenda={image?.legenda}
            credito={image?.credito}
            fonte={image?.fonte}
            width={2000}
            height={1000}
          />
        );
      case 'secaoJogosBrincadeiras':
        return (
          <GamesAndPlay
            content={formattedString}
            subject="portuguese"
            color={50}
          />
        );
      case 'secaoProximaAula':
        return (
          <NextClass
            title="Para a próxima aula"
            content={formattedString}
            subject="portuguese"
          />
        );
      case 'citacao':
        return (
          <Quotations
            content={formattedString}
            font=""
            title=""
            subject="portuguese"
          />
        );
      case 'anexo':
        return <Attachment path={attachmentPath} subject="portuguese" />;
      case 'midiaAudio':
      case 'midiaVideo':
        return <MediaPlayer retranca={stringContent} type={child.classList[0]} />;
      case 'boxDestaque':
        return <Highlight subject="portuguese">{formattedString}</Highlight>;
      case 'secaoRodaGigante':
        return (
          <ProjectBox
            componentType={child.classList[0]}
            object={stringTableContent}
          />
        );
      case 'tabs':
        return <TabContent tabs={extractTabsFromTable(child)} />;
      case 'boxSimples':
        return (
          <div className="boxSimples">
            {parse(stringContent, { replace })}
          </div>
        );
      default:
        return (
          parse(stringContent, { replace })
        );
    }
  };

  return (
    <NotesContextProvider notes={notes} replace={replace}>
      <WrapContent title={title} subject="portuguese" isLesson>
        {childrenArray.map((child) => renderContent(child))}
      </WrapContent>
    </NotesContextProvider>
  );
}
